import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './SideBar.jsx';
import TopNavbar from './Navbar.jsx';

const DashboardLayout = () => {
  const location = useLocation();

  const routeMap = {
  };

  const path = location.pathname;
  const basePath = `/${path.split('/')[1]}`; // gets the first segment
  const activeLabel = routeMap[basePath] || '';
  const breadcrumbPath = ['Dashboard', activeLabel];

  return (
    <div className="dashboard-layout">
      <Sidebar />
      <div className="main-content">
        <TopNavbar path={breadcrumbPath.slice(1)} />
        <Outlet />
      </div>
    </div>
  );
};

export default DashboardLayout;
